import { paymentSources } from 'client/GrowthEngineering/utilities/GrowthConstants';
import ModalEventBus from 'components/Modal/ModalEventBus';
import PaymentHelper from 'client/Payments/PaymentHelper';
import store from 'client/store';

export function createSubmitPaymentService(storeModule = store) {
  return {
    openPaymentsModal(paymentSource = paymentSources.userMenuDropdown) {
      if (storeModule.getters['SettingsModule/isProvider']) {
        ModalEventBus.open({
          isLargeModal: false,
          component: 'OnlyAllowProviderPaymentsModal',
        });
      } else if (storeModule.getters['SettingsModule/hasBilling']) {
        PaymentHelper.openPaymentModal(paymentSource);
      } else {
        ModalEventBus.open({
          isLargeModal: false,
          component: 'NoBillingPermissionsModal',
        });
      }
    },
  };
}
export default createSubmitPaymentService();
